import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import AddShadowImage from "../../../assets/ProductShot/images/api-add-shadow.png";
import BrandingImage from "../../../assets/ProductShot/images/api-branding.png";
import CutoutImage from "../../../assets/ProductShot/images/api-cutout.png";
import HarmonizationImage from "../../../assets/ProductShot/images/api-harmonization.png";
import KeywordExtractImage from "../../../assets/ProductShot/images/api-keyword-extract.png";
import LifestyleByImageImage from "../../../assets/ProductShot/images/api-lifestyle-by-image.png";
import LifestyleByTextImage from "../../../assets/ProductShot/images/api-lifestyle-by-text.png";
import PackshotImage from "../../../assets/ProductShot/images/api-packshot.png";
import ReflectionsImage from "../../../assets/ProductShot/images/api-reflections.png";
import SegmentVehicleImage from "../../../assets/ProductShot/images/api-segment-vehicle.png";
import VehicleByTextImage from "../../../assets/ProductShot/images/api-vehicle-by-text.png";
import VisualEffectImage from "../../../assets/ProductShot/images/api-visual-effect.png";
import WheelsImage from "../../../assets/ProductShot/images/api-wheels.png";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";

const ProductShotAPI = () => {
	const { t } = useTranslation("translation", { keyPrefix: "productShot.api" });

	const openDocs = (link: string) => window.open(link, "_blank");

	const productShotApiCards: ConsoleAPICardProps[] = [
		{
			image: CutoutImage,
			header: t("cards.cutout.header"),
			description: t("cards.cutout.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.CUTOUT.DOCS)}>
					{t("cards.cutout.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.CUTOUT.DOCS),
		},
		{
			image: PackshotImage,
			header: t("cards.packshot.header"),
			description: t("cards.packshot.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.PACKSHOT.DOCS)}>
					{t("cards.packshot.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.PACKSHOT.DOCS),
		},
		{
			image: AddShadowImage,
			header: t("cards.addShadow.header"),
			description: t("cards.addShadow.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.ADD_SHADOW.DOCS)}>
					{t("cards.addShadow.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.ADD_SHADOW.DOCS),
		},
		{
			image: LifestyleByImageImage,
			header: t("cards.lifestyleByImage.header"),
			description: t("cards.lifestyleByImage.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.LIFESTYLE_BY_IMAGE.DOCS)}
				>
					{t("cards.lifestyleByImage.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.LIFESTYLE_BY_IMAGE.DOCS),
		},
		{
			image: LifestyleByTextImage,
			header: t("cards.lifestyleByText.header"),
			description: t("cards.lifestyleByText.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.LIFESTYLE_BY_TEXT.DOCS)}
				>
					{t("cards.lifestyleByText.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.LIFESTYLE_BY_TEXT.DOCS),
		},
		{
			image: BrandingImage,
			header: t("cards.branding.header"),
			description: t("cards.branding.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.BRANDING.DOCS)}>
					{t("cards.branding.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.BRANDING.DOCS),
		},
		{
			image: KeywordExtractImage,
			header: t("cards.keywordExtract.header"),
			description: t("cards.keywordExtract.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.KEYWORD_EXTRACT.DOCS)}
				>
					{t("cards.keywordExtract.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.KEYWORD_EXTRACT.DOCS),
		},
	];

	const automotiveCards: ConsoleAPICardProps[] = [
		{
			image: VehicleByTextImage,
			header: t("automotive.cards.vehicleByText.header"),
			description: t("automotive.cards.vehicleByText.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.VEHICLE_BY_TEXT.DOCS)}
				>
					{t("automotive.cards.vehicleByText.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.VEHICLE_BY_TEXT.DOCS),
		},
		{
			image: SegmentVehicleImage,
			header: t("automotive.cards.segmentVehicle.header"),
			description: t("automotive.cards.segmentVehicle.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.SEGMENT_VEHICLE.DOCS)}
				>
					{t("automotive.cards.segmentVehicle.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.SEGMENT_VEHICLE.DOCS),
		},
		{
			image: WheelsImage,
			header: t("automotive.cards.refineTires.header"),
			description: t("automotive.cards.refineTires.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.WHEELS.DOCS)}
				>
					{t("automotive.cards.refineTires.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.WHEELS.DOCS),
		},
		{
			image: ReflectionsImage,
			header: t("automotive.cards.reflections.header"),
			description: t("automotive.cards.reflections.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.REFLECTIONS.DOCS)}
				>
					{t("automotive.cards.reflections.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.REFLECTIONS.DOCS),
		},
		{
			image: VisualEffectImage,
			header: t("automotive.cards.visualEffect.header"),
			description: t("automotive.cards.visualEffect.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.VISUAL_EFFECT.DOCS)}
				>
					{t("automotive.cards.visualEffect.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.VISUAL_EFFECT.DOCS),
		},
		{
			image: HarmonizationImage,
			header: t("automotive.cards.harmonization.header"),
			description: t("automotive.cards.harmonization.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.HARMONIZATION.DOCS)}
				>
					{t("automotive.cards.harmonization.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.PRODUCT_SHOT.AUTOMOTIVE.HARMONIZATION.DOCS),
		},
	];

	return (
		<ConsoleAPILayout description={t("description")}>
			<ConsoleAPICards cards={productShotApiCards} />
			<ConsoleAPICards title={t("automotive.title")} cards={automotiveCards} />
		</ConsoleAPILayout>
	);
};

export default observer(ProductShotAPI);
